import EditorPage from './EditorPage';

export default EditorPage;
